<template lang="pug">
  v-tooltip(top :disabled="!tooltipText")
    template(v-slot:activator="{ on, attrs }")
      div(
        v-on="on"
        v-bind="attrs"
      )
        e-status-chip(
          :value="value"
          :statuses="statuses"
          :only-text="onlyText"
        )
    span {{ tooltipText }}
</template>

<script>
import EStatusChip from '~/components/elements/e-status-chip'

export default {
  name: 'EChipStatusTooltip',
  components: { EStatusChip },
  props: {
    value: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: null
    },
    statuses: {
      type: Array,
      default: () => []
    },
    onlyText: {
      type: Boolean,
      default: false
    },
    tooltipItemKey: {
      type: String,
      default: null
    }
  },
  computed: {
    tooltipText() {
      return this._.get(this.item, this.tooltipItemKey, null)
    }
  }
}
</script>

<style scoped lang="scss"></style>
